module.exports = __webpack_public_path__ + "media/images/landing__seasonPrize__prize1-341a559affcb17b39f6522d00959212a.jpg";